import { useState } from "react";
import { MoreVertical, ChevronDown, Search } from "lucide-react";
import SupplierInteractionHistory from "./SupplierInteractionHistory";
import SearchFilter from "./SearchFilter";

const dummyEngagement = [
  {
    supplier: "Qualcomm",
    email: "jdoe@qualcomm.com",
    user: "Bosun Awodiya",
    industry: "Consumer Hardware",
    date: "Mar 16, 2025, 10:00 PM",
    cert: "MBE",
    status: "Small Business",
  },

  {
    supplier: "Qualcomm",
    email: "jdoe@qualcomm.com",
    user: "Bosun Awodiya",
    industry: "Consumer Hardware",
    date: "Mar 16, 2025, 10:00 PM",
    cert: "MBE",
    status: "Small Business",
  },
];

const dummyActivity = [
  {
    supplier: "John Doe",
    email: "jdoe@talkdei.io",
    time: "Mar 16, 2025, 10:00 PM",
    user: "Simon Fox",
    details: "Contract #12345 signed",
    attachment: "linktoattachment.pdf",
    type: "Contact Signed",
    typeColor: "text-green-600",
  },
  {
    supplier: "John Doe",
    email: "jdoe@talkdei.io",
    time: "Mar 16, 2025, 10:00 PM",
    user: "Simon Fox",
    details: "RFQ for steel components",
    attachment: "linktoattachment.pdf",
    type: "RFQ Sent",
    typeColor: "text-orange-600",
  },
];

const dummySuppliers = [
  { name: "John Doe", email: "jdoe@talkdei.io", score: 8.8 },
  { name: "John Doe", email: "jdoe@talkdei.io", score: 5.4 },
  { name: "John Doe", email: "jdoe@talkdei.io", score: 3.2 },
];

function ThreeDotMenu() {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)}>
        <MoreVertical size={18} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-32 bg-white border rounded shadow-lg z-10">
          <ul className="text-sm">
            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
              Item 1
            </li>
            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
              Item 2
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default function Admin() {
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  return (
    <>
      {selectedSupplier ? (
        <SupplierInteractionHistory
          supplier={selectedSupplier}
          onBack={() => setSelectedSupplier(null)}
        />
      ) : (
        <div className="p-6 space-y-8">
          <span className="flex justify-start text-2xl text-left text-[#1D2739]">
            Admin
          </span>
          {/* Engagement Metrics */}
          <div>
            <h2 className="text-basde font-medium mb-3 text-left text-[#1D2739]">
              Engagement Metrics
            </h2>
            <div className="bg-white rounded-lg shadow">
              <SearchFilter expandData={dummyEngagement}  />
              <table className="min-w-full bg-white shadow rounded-lg">
                <thead className="text-left text-sm font-medium text-[#1D2739] border-b bg-[#F7F7F7]">
                  <tr>
                    <th className="p-4 w-[15%]">Supplier Information</th>
                    <th className="p-4 w-[15%]">User</th>
                    <th className="p-4 w-[15%]">Industry</th>
                    <th className="p-4 w-[20%]">Engagement Date</th>
                    <th className="p-4 w-[15%]">Certifications</th>
                    <th className="p-4 w-[15%]">Diversity Status</th>
                    <th className="p-4 w-[5%]"></th>
                  </tr>
                </thead>
                <tbody>
                  {dummyEngagement.map((row, i) => (
                    <tr key={i} className="border-t">
                      <td className="px-4 py-2">
                        <div className="flex flex-col">
                          <span className="font-medium">{row.supplier}</span>
                          <span className="text-gray-500 text-xs">
                            {row.email}
                          </span>
                        </div>
                      </td>
                      <td className="p-4">{row.user}</td>
                      <td className="p-4">{row.industry}</td>
                      <td className="p-4">{row.date}</td>
                      <td className="p-4 text-blue-600">{row.cert}</td>
                      <td className="p-4 text-green-600">{row.status}</td>
                      <td className="p-3 text-right">
                        <ThreeDotMenu />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Activity Log */}
          <div>
            <h2 className="text-basde font-medium mb-3 text-left text-[#1D2739]">
              Activity Log
            </h2>
            <div className="bg-white rounded-lg shadow">
              <SearchFilter />
              <table className="w-full text-sm">
                <thead className="bg-gray-50 text-left">
                  <tr>
                    <th className="p-4 w-[15%]">Supplier Name</th>
                    <th className="p-4 w-[20%]">Timestamp</th>
                    <th className="p-4 w-[15%]">User</th>
                    <th className="p-4 w-[22%]">Details</th>
                    <th className="p-4 w-[12%]">Attachments</th>
                    <th className="p-4 w-[15%]">Activity Type</th>
                    <th className="p-4 w-[5%]"></th>
                  </tr>
                </thead>
                <tbody>
                  {dummyActivity.map((row, i) => (
                    <tr key={i} className="border-t">
                      <td className="px-4 py-2">
                        <div className="flex flex-col">
                          <span className="font-medium">{row.supplier}</span>
                          <span className="text-gray-500 text-xs">
                            {row.email}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-2">{row.time}</td>
                      <td className="px-4 py-2">{row.user}</td>
                      <td className="px-4 py-2">{row.details}</td>
                      <td className="px-4 py-2 text-blue-600">
                        <a href="#">{row.attachment}</a>
                      </td>
                      <td className={`px-4 py-2 ${row.typeColor}`}>
                        {row.type}
                      </td>
                      <td className="p-3 text-right">
                        <ThreeDotMenu />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Supplier Directory */}
          <div>
            <h2 className="text-basde font-medium mb-3 text-left text-[#1D2739]">
              Supplier Directory
            </h2>
            <div className="bg-white rounded-lg shadow">
              <SearchFilter expandData={dummySuppliers} />
              <table className="w-full text-sm text-[#1D2739]">
                <thead className="bg-gray-50 text-left">
                  <tr>
                    <th className="p-4">Supplier Name</th>
                    <th className="p-4">Email</th>
                    <th className="p-4">Overall Rating Score</th>
                    <th className="p-4"></th>
                  </tr>
                </thead>
                <tbody>
                  {dummySuppliers.map((row, i) => (
                    <tr key={i} className="border-t">
                      <td className="px-4 py-2">{row.name}</td>
                      <td className="px-4 py-2">{row.email}</td>
                      <td
                        className={`px-4 py-2 font-semibold ${
                          row.score >= 7
                            ? "text-green-600"
                            : row.score >= 5
                            ? "text-yellow-600"
                            : "text-red-600"
                        }`}
                      >
                        {row.score}
                      </td>
                      <td className="px-4 py-2 flex justify-between">
                        <button
                          className="px-3 py-1 text-sm border rounded-full hover:bg-gray-100"
                          onClick={() => setSelectedSupplier(row)}
                        >
                          View Supplier Interaction History
                        </button>
                        <ThreeDotMenu />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
